import {FormControl, ValidationErrors, Validator} from '@angular/forms';

/**
 * Does not accept only white spaces
 * Blank value is always correct.
 *
 */
export class NoWhitespaceValidator implements Validator {

    public static validator() {
        const validator = new NoWhitespaceValidator();
        return (control: FormControl): ValidationErrors | null => validator.validate(control);
    }

    validate(control: FormControl): ValidationErrors | null {
        const val = (control.value || '');
        const isWhitespace = val.length && val.trim().length === 0;
        const isValid = !isWhitespace;
        return isValid ? null : {'whitespace': true};
    }
}
